import { useState, useEffect } from 'react';
import NetworkService from '../../NetworkService';

export const useUserAutocomplete = (initialQuery = '', debounceDelay = 700) => {
  const [query, setQuery] = useState(initialQuery);
  const [debouncedQuery, setDebouncedQuery] = useState(query);
  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedQuery(query), debounceDelay);
    return () => clearTimeout(handler);
  }, [query, debounceDelay]);

  useEffect(() => {
    if (debouncedQuery.length > 0 && debouncedQuery.length < 3) {
      setData([]);
      return;
    }

    let isMounted = true;
    setIsFetching(true);

    NetworkService.getUsers({ page: 1, size: 5 }, debouncedQuery)
      .then((res) => {
        if (isMounted) {
          setData(Array.isArray(res) ? res : res?.data || []);
        }
      })
      .catch(() => isMounted && setData([]))
      .finally(() => isMounted && setIsFetching(false));

    return () => { isMounted = false; };
  }, [debouncedQuery]);

  const options = data.map((item) => {
    const name = `${item.firstName || ''} ${item.lastName || ''}`.trim();
    return {
      label: `${name}`,
      value: item.id,
      user: item,
      groupLabel: 'Users'
    };
  });

  return {
    options,
    isLoading: isFetching,
    onSearch: setQuery
  };
};
